import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";

import translate from "../../../../services/Translate";
import { MeetingCurrentFilters } from "../../Meetings.d";
import type { SelectCustomFilterProps } from "./CustomFilterDropdown.d";

const CustomFilterDropdown = ({
  closeModal,
  language,
  show,
  onApplyFilter,
  activeCustomFilter,
}: SelectCustomFilterProps) => {
  const [customFilters, setCustomFilters] = useState<Record<string, MeetingCurrentFilters>>({});

  useEffect(() => {
    if (show) {
      try {
        const savedFilters = JSON.parse(localStorage.getItem("nexus-custom-filters-meetings") || "{}");
        setCustomFilters(savedFilters);
      } catch (error) {
        console.error("An error occurred with custom filters.", error);
        setCustomFilters({});
      }
    }
  }, [show]);

  const _applySelectedFilter = (filterName: string) => {
    if (!filterName || !customFilters[filterName]) {
      return;
    }

    onApplyFilter(customFilters[filterName], filterName);
    closeModal();
  };

  const _applyDefaultFilter = () => {
    onApplyFilter(
      {
        meetingTypes: [],
        authors: [],
        animators: [],
        programs: [],
      },
      ""
    );
    closeModal();
  };

  const _deleteFilter = (filterName: string, event: React.MouseEvent) => {
    event.stopPropagation();

    if (
      !window.confirm(
        translate(language, "PAGES.MEETINGS.FILTERS.SELECT_MODAL.CONFIRM_DELETE").replace("{{FILTER_NAME}}", filterName)
      )
    )
      return;

    const updatedFilters = { ...customFilters };
    delete updatedFilters[filterName];
    localStorage.setItem("nexus-custom-filters-meetings", JSON.stringify(updatedFilters));
    setCustomFilters(updatedFilters);
  };

  const filterNames = Object.keys(customFilters);
  const isDefaultActive = !activeCustomFilter;

  if (!show) return null;

  return (
    <Dropdown.Menu show className="dropup">
      <Dropdown.Header>{translate(language, "PAGES.MEETINGS.FILTERS.SELECT_MODAL.TITLE")}</Dropdown.Header>
      <div
        className={`s-regular clickable d-flex align-items-center px-3 py-2 ${isDefaultActive ? "active" : ""} ${
          !isDefaultActive ? "dropdown-item" : ""
        }`}
        onClick={_applyDefaultFilter}
      >
        <div>{translate(language, "PAGES.MEETINGS.FILTERS.DEFAULT_FILTER")}</div>
        {isDefaultActive && (
          <div className="s-regular ms-2">
            <span className="dst-icon-check-circle" />
          </div>
        )}
      </div>
      {filterNames.length === 0 ? (
        <Dropdown.ItemText>
          <div className="text-muted xs-regular">
            {translate(language, "PAGES.MEETINGS.FILTERS.SELECT_MODAL.NO_FILTERS")}
          </div>
        </Dropdown.ItemText>
      ) : (
        filterNames.map((filterName) => {
          const isActive = activeCustomFilter === filterName;

          return (
            <div
              key={filterName}
              className={`s-regular clickable d-flex align-items-center justify-content-between px-3 py-2 ${
                isActive ? "active" : ""
              } ${!isActive ? "dropdown-item" : ""}`}
              onClick={() => _applySelectedFilter(filterName)}
            >
              <div className="d-flex align-items-center">
                <div className="s-regular text-truncate" style={{ maxWidth: 250 }}>
                  {filterName}
                </div>
                {isActive && (
                  <div className="ms-2">
                    <span className="dst-icon-check-circle" />
                  </div>
                )}
              </div>

              <i
                className="dst-icon-trash-01 text-danger ms-3 clickable"
                onClick={(event) => _deleteFilter(filterName, event)}
              />
            </div>
          );
        })
      )}
    </Dropdown.Menu>
  );
};

export default CustomFilterDropdown;
